export default "__VITE_ASSET__5a38e65d__"